<template>

  <v-container fluid>
    
    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field counter="50" :rules="[ v => (v.length <= 50) || $t('eventschedult_msg9') ]" 
                  v-model="editedItem.NAME" :label="$t('eventschedult_col1')" outlined
                  />
              </v-row>
              <v-row class="mt-5" dense justify="center"> 
                  <label style="font-size:16px">{{$t('eventschedult_col2')}}</label>
                  <datetime input-style="margin-left:10px; border-bottom:1px solid gray; text-align:center; font-size:16px" 
                          :format="$t('eventschedult_label2')" type="date" value-zone="Asia/Seoul"
                          v-model="editedItem.SCHEDULE_DATE" :title="$t('eventschedult_col2')" @input="select_scheduledate"
                          />
                  <!-- <comdate :inputdate="editedItem.SCHEDULE_DATE" labeltext="일정일" @callback="select_scheduledate"></comdate> -->
              </v-row>
              <v-row class="mt-5" align="center" justify="center"> 
                <v-col cols="6">
                  <v-row justify="center">
                    <label style="margin:10px;font-size:16px">{{$t('eventschedult_col3')}}</label>
                    <datetime input-style="margin-left:10px; border-bottom:1px solid gray; text-align:center;font-size:16px;width:120px" 
                              type="time" @input="select_starttime" value-zone="Asia/Seoul"
                              v-model="editedItem.START_TIME" :title="$t('eventschedult_col3')" 
                              />
                  </v-row>
                </v-col>                          
                <!-- <comtime :inputtime="editedItem.START_TIME" labeltext="시작시간" @callback="select_starttime"></comtime> -->
                <v-col cols="6">
                  <v-row justify="center">
                    <label style="margin:10px;font-size:16px">{{$t('eventschedult_col4')}}</label>
                    <datetime input-style="margin-left:10px; border-bottom:1px solid gray; text-align:center;font-size:16px;width:120px" 
                            type="time" @input="select_endtime" value-zone="Asia/Seoul"
                            v-model="editedItem.END_TIME" :title="$t('eventschedult_col4')" 
                            />
                  </v-row>
                </v-col>
                <!-- <comtime :inputtime="editedItem.END_TIME" labeltext="종료시간" @callback="select_endtime"></comtime> -->
              </v-row>
              <v-row class="mt-5" dense> 
                <v-text-field outlined counter="50" :rules="[ v => (v.length <= 50) || $t('eventschedult_msg12') ]" 
                v-model="editedItem.LOCATION" :label="$t('eventschedult_col5')"></v-text-field>
              </v-row>
              <v-row class="mt-5" dense> 
                <v-col>
                  <v-textarea counter="1000" v-model="editedItem.DESC" :label="$t('eventschedult_col6')" value="" outlined :rules="[ v => (v.length <= 1000) || $t('eventschedult_msg14') ]"></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row align="center" justify="end" dense>
      <v-col cols="12" md="2" sm="12" xs="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <template v-if="grade >= 50">
        <v-col cols="12" md="3" sm="12" xs="12">
          <comdialog  :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
      </template>
      <v-col cols="12" md="3" sm="12" xs="12">
        <eventdialog  :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" outlined large @click="search_run">{{$t('common_search_list')}}</v-btn>
      </v-col>        
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="newinsert">{{$t("common_insert")}}</v-btn>
        <!-- <v-btn class="search_btn" small rounded color="error" @click="delete_select">삭제</v-btn> -->
      </v-col>
    </v-row>
    
  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        class="datatablestyle"
        item-key="IDX"
        :loading="loading"
        :items-per-page="9999"
        v-model="selected"
        >
        <template v-slot:header.NAME>
          <label class="cheader_normal" >{{$t("eventschedult_col1")}}</label>
        </template>
        <template v-slot:header.SCHEDULE_DATE>
          <label class="cheader_normal" >{{$t("eventschedult_col2")}}</label>
        </template>
        <template v-slot:header.START_TIME>
          <label class="cheader_normal" >{{$t("eventschedult_col3")}}</label>
        </template>
        <template v-slot:header.END_TIME>
          <label class="cheader_normal" >{{$t("eventschedult_col4")}}</label>
        </template>
        <template v-slot:header.LOCATION>
          <label class="cheader_normal" >{{$t("eventschedult_col5")}}</label>
        </template>
        <template v-slot:header.DESC>
          <label class="cheader_normal" >{{$t("eventschedult_col6")}}</label>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("eventschedult_col7")}}</label>
        </template>
        <template v-slot:header.copy>
          <label class="cheader_normal" >{{$t("eventschedult_col8")}}</label>
        </template>

        <template v-slot:item.NAME="{ item }">  
          <label> {{ item.NAME.length > 20 ? item.NAME.substring(0,20)+"..." : item.NAME }} </label>
        </template>
        <template v-slot:item.SCHEDULE_DATE="{ item }">  
          <label> {{ item.SCHEDULE_DATE + getDayName(item.DAYCODE) }} </label>
        </template>
        <template v-slot:item.LOCATION="{ item }">  
          <label> {{ item.LOCATION.length > 20 ? item.LOCATION.substring(0,20)+"..." : item.LOCATION }} </label>
        </template>
        <template v-slot:item.DESC="{ item }">  
          <label> {{ item.DESC.length > 20 ? item.DESC.substring(0,20)+"..." : item.DESC }} </label>
        </template>
        <template v-slot:item.actions="{ item }">  
            <v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
            <v-icon small @click="delete_item(item)">mdi-delete</v-icon>
        </template>     
        <template v-slot:item.copy="{ item }">  
            <v-icon small @click="copy_item(item)">mdi-content-copy</v-icon>
        </template>     
      </v-data-table>
    </v-col>
  </v-row>

  </v-container>
</template>

<script>
//import dateFormat from 'dateformat'
import moment from 'moment'
export default {
    data: () => ({

      //필수 페이징 파라메터
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
          NAME:'',
          DESC:'',
          LOCATION:'',
          SCHEDULE_DATE:'',
          START_TIME:'',
          END_TIME:'',
      },
      editedItem: {
      },
      selected:[],              //테이블에 선택된 아이템 리스트

      //테이블 정의
      headers: [
        {text: '일정명', value: 'NAME', sortable: true, align:'center' },
        {text: '일정일', value: 'SCHEDULE_DATE', sortable: true, align:'center'},
        {text: '시작시간', value: 'START_TIME', sortable: true, align:'center'},
        {text: '종료시간', value: 'END_TIME', sortable: true, align:'center'},
        {text: '장소', value: 'LOCATION', sortable: true, align:'center'},
        {text: '설명', value: 'DESC', sortable: true, align:'center'},
        {text: '수정/삭제', value: 'actions', sortable: false, align:'center'},
        {text: '복사', value: 'copy', sortable: false, align:'center'}
      ],
      itemList: [],

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',

      grade : 0,

    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
      

    },

    create(){

    },

    methods: {

      getDayName(daycode){
        var dayname = "";
        if(daycode == 0){
          dayname = this.$t('eventschedult_msg1');
        }else if(daycode == 1){
          dayname = this.$t('eventschedult_msg2');
        }else if(daycode == 2){
          dayname = this.$t('eventschedult_msg3');
        }else if(daycode == 3){
          dayname = this.$t('eventschedult_msg4');
        }else if(daycode == 4){
          dayname = this.$t('eventschedult_msg5');
        }else if(daycode == 5){
          dayname = this.$t('eventschedult_msg6');
        }else if(daycode == 6){
          dayname = this.$t('eventschedult_msg7');
        }
        return dayname;
      },

      //멀티 선택 삭제
      delete_select(){
        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          
          this.loading = true;
          this.$http.post(this.$host+'/api/ScheduleDeleteAll',{
              DELETE_IDXS: escape(JSON.stringify(this.selected))
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                this.loadpage();
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });
      },

      // eslint-disable-next-line no-unused-vars
      visibilityChanged (isVisible, entry) {
        //console.log("visibilityChanged 1 " + isVisible + " / " + entry);
      },

      loadpage(){
          
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화

          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
          if(this.SEARCH_EVENT_IDX == null){
            this.$alert(this.$t('common_select_tevent'));
            return;
          }

          this.loading = true;

          this.$http.post(this.$host+'/api/ScheduleList',{
                COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{

            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                const list = result.data.resultData;
                
                list.forEach(element => {
                    this.itemList.push(element); 
                });

                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage();
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        this.dialog_pw  = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      //추가 저장
      save () {
        
        if(this.editedItem.NAME  == undefined || this.editedItem.NAME.length < 1){
          this.$alert(this.$t('eventschedult_msg8'));
          return;
        } 
        if(this.editedItem.NAME.length > 50){
          this.$alert(this.$t('eventschedult_msg9'));
          return;
        } 

        if(this.editedItem.SCHEDULE_DATE == undefined || this.editedItem.SCHEDULE_DATE.length < 1){
          this.$alert(this.$t('eventschedult_msg10'));
          return;
        } 

        if(this.editedItem.LOCATION == undefined || this.editedItem.LOCATION.length < 1){
          this.$alert(this.$t('eventschedult_msg11'));
          return;
        } 
        if(this.editedItem.LOCATION.length > 50){
          this.$alert(this.$t('eventschedult_msg12'));
          return;
        } 

        if(this.editedItem.DESC == undefined || this.editedItem.DESC.length < 1){
          this.$alert(this.$t('eventschedult_msg13'));
          return;
        } 
        if(this.editedItem.DESC.length > 1000){
          this.$alert(this.$t('eventschedult_msg14'));
          return;
        } 


        if (this.editedIndex > -1) {

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/ScheduleUpdate',{
                IDX: this.editedItem.IDX
              , NAME: escape(this.editedItem.NAME)
              , SCHEDULE_DATE: this.editedItem.SCHEDULE_DATE
              , START_TIME: this.editedItem.START_TIME
              , END_TIME: this.editedItem.END_TIME
              , LOCATION: escape(this.editedItem.LOCATION)
              , DESC: escape(this.editedItem.DESC)
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  this.loadpage();
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });


        }else{
          
          //신규
          this.loading = true;
          this.$http.post(this.$host+'/api/ScheduleInsert',{
                COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , NAME: escape(this.editedItem.NAME)
              , SCHEDULE_DATE: this.editedItem.SCHEDULE_DATE
              , START_TIME: this.editedItem.START_TIME
              , END_TIME: this.editedItem.END_TIME
              , LOCATION: escape(this.editedItem.LOCATION)
              , DESC: escape(this.editedItem.DESC)
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t('common_insert_msg')).then(()=>{
                this.loadpage();
              });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_insert_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_insert_fail"));
          });


        }

        this.close()
      },      

      //검색
      search_run(){
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }
        this.loadpage();
      },
      
      //신규 추가
      newinsert(){
        
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        this.dialogTitle = this.$t('common_insert_title');
        this.editedIndex  = -1;
        //this.editedItem = Object.assign({}, this.defaultItem)
        this.editedItem = {};

        this.editedItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
        this.editedItem.EVENT_NAME  = this.SEARCH_EVENT_NAME

        this.editedItem.START_TIME  = '09:00';
        this.editedItem.END_TIME    = '18:00';

        this.dialog = true;
      },

      //아이템 복제
      copy_item(item){
        this.dialogTitle = this.$t('common_insert_title');
        this.editedIndex  = -1;

        //item값을 클론해야함. 영향이 안가도록
        this.editedItem = JSON.parse(JSON.stringify(item));
        //this.editedItem = Object.assign({}, item);  //이건 얉은 카피
        this.editedItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
        this.editedItem.EVENT_NAME  = this.SEARCH_EVENT_NAME;
        this.dialog = true;
      },

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item)
        //this.editedItem = item;
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/ScheduleDelete',{
              IDX:item.IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                this.loadpage();
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
        }else{
          //일단 업체 선택이 취소되면 리스트를 초기화 시켜야한다.
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        this.loadpage();
      },


      //행사날자 선택 콜백
      select_scheduledate(var1){
        
        this.editedItem.SCHEDULE_DATE = var1;
      },

      select_starttime(var1){
        this.editedItem.START_TIME = moment(var1).format("HH:mm");
      },

      select_endtime(var1){
        this.editedItem.END_TIME = moment(var1).format("HH:mm");
      },


      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.itemList.splice(0, this.itemList.length);   //데이터 초기화
      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
      },



    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>


</style>